import React from 'react'
import { SectionTitle } from '@diversioteam/diversio-ds'

import { ParticipationRateProps } from './participationRate.types'
import * as S from './participationRate.styles'

export const ParticipationRate = ({ completedSurveys, totalEmployees }: ParticipationRateProps) => {
    const hasTotalEmployees = totalEmployees !== null

    const participationPercentage = hasTotalEmployees ? Math.round((completedSurveys / totalEmployees) * 100) : null

    return (
        <S.ParticipationWrapper>
            <SectionTitle text="Participation rate" icon={null} />

            <S.Content>
                {hasTotalEmployees ? (
                    <>
                        <S.Count>{participationPercentage}%</S.Count>

                        <S.Description>
                            <span>
                                {completedSurveys} of {totalEmployees} people
                            </span>

                            <span>completed the survey</span>
                        </S.Description>
                    </>
                ) : (
                    <>
                        <S.Count>{completedSurveys}</S.Count>

                        <S.Description>Completed survey</S.Description>
                    </>
                )}
            </S.Content>
        </S.ParticipationWrapper>
    )
}
